module.exports = __webpack_public_path__ + "img/包年图源.25013424.png";